import { Resource } from './resource';
import gql from 'graphql-tag';

export class LogicalStructureResource extends Resource {
  public static async list() {
    return await this.query(
      {
        query: gql`
          query {
            logicalStructure {
              id
              name
              hasChildren
              parentId
              children {
                id
                name
                hasChildren
                parentId
              }
            }
          }
        `
      },
      'logicalStructure'
    );
  }

  public static async simpleList() {
    return await this.query(
      {
        query: gql`
          query {
            logicalStructure {
              id
              name
            }
          }
        `
      },
      'logicalStructure'
    );
  }

  public static async fullList() {
    const list = await this.query(
      {
        query: gql`
          query {
            getTree
          }
        `
      },
      'getTree'
    );
    return JSON.parse(list);
  }

  public static async children(parentId: number) {
    return await this.query(
      {
        query: gql`
          query($parentId: Int) {
            logicalStructure(parentId: $parentId) {
              id
              name
              hasChildren
              parentId
              parent {
                id
                name
                hasChildren
                parentId
              }
            }
          }
        `,
        variables: { parentId }
      },
      'logicalStructure'
    );
  }

  public static async get(id: number) {
    return await this.query(
      {
        query: gql`
          query($id: Int!) {
            nodeGet(id: $id) {
              id
              name
              hasChildren
              parentId
              parent {
                id
                name
                hasChildren
                parentId
              }
              children {
                id
                name
                hasChildren
                parentId
              }
            }
          }
        `,
        variables: { id }
      },
      'nodeGet'
    );
  }

  public static async add(name: string, parentId: number) {
    return await this.mutation(
      {
        mutation: gql`
          mutation($name: String!, $parentId: Int!) {
            nodeCreate(node: { name: $name, parentId: $parentId }) {
              id
              name
              parentId
              active
            }
          }
        `,
        variables: { name, parentId }
      },
      'nodeCreate'
    );
  }

  public static async delete(id: number) {
    return await this.mutation(
      {
        mutation: gql`
          mutation($id: Int!) {
            nodeDelete(id: $id)
          }
        `,
        variables: { id }
      },
      'nodeDelete'
    );
  }

  public static async update(id: number, name: string) {
    return await this.mutation(
      {
        mutation: gql`
          mutation($id: Int!, $name: String!) {
            nodeNameUpdate(id: $id, name: $name) {
              id
              name
            }
          }
        `,
        variables: { id, name },
        refetchQueries: [
          {
            query: gql`
              query {
                getTree
              }
            `
          }
        ]
      },
      'nodeNameUpdate'
    );
  }

  public static async changeParent(id: number, parentId: number, oldParentId: number) {
    return await this.mutation(
      {
        mutation: gql`
          mutation($id: Int!, $parentId: Int!) {
            nodeUpdate(id: $id, parentId: $parentId) {
              id
              name
              parentId
              parent {
                id
              }
            }
          }
        `,
        variables: { id, parentId },
        refetchQueries: [
          {
            query: gql`
              query {
                getTree
              }
            `
          },
          {
            query: gql`
              query($oldParentId: Int!) {
                nodeGet(id: $oldParentId) {
                  id
                  name
                  hasChildren
                  parentId
                  parent {
                    id
                    name
                    hasChildren
                    parentId
                  }
                  children {
                    id
                    name
                    hasChildren
                    parentId
                  }
                }
              }
            `,
            variables: { oldParentId }
          },
          {
            query: gql`
              query($parentId: Int!) {
                nodeGet(id: $parentId) {
                  id
                  name
                  hasChildren
                  parentId
                  parent {
                    id
                    name
                    hasChildren
                    parentId
                  }
                  children {
                    id
                    name
                    hasChildren
                    parentId
                  }
                }
              }
            `,
            variables: { parentId }
          },
          {
            query: gql`
              query($parentId: Int) {
                logicalStructure(parentId: $parentId) {
                  id
                  name
                  hasChildren
                  parentId
                  parent {
                    id
                    name
                    hasChildren
                    parentId
                  }
                }
              }
            `,
            variables: { parentId }
          },
          {
            query: gql`
              query($oldParentId: Int) {
                logicalStructure(parentId: $oldParentId) {
                  id
                  name
                  hasChildren
                  parentId
                  parent {
                    id
                    name
                    hasChildren
                    parentId
                  }
                }
              }
            `,
            variables: { oldParentId }
          }
        ]
      },
      'nodeUpdate'
    );
  }
}
